<template>
<div class="container-fluid">
         
         <div class="chat-bar-container">
            <button class="back-profile mb-2"
            @click="backProfile"
            >
                <img src="../../assets/arrow-back-pink.png" alt="" style="width: 20px;"> &nbsp; 
            </button>
            <button class="chat-bar" @click="toggleGuestList" v-if="user_role === 'escort'" >
                <!-- <i class="fa fa-bars"></i> -->
            </button>
         </div>
         <span class="text-white show-mobile"></span>
         <div class="chat-client-top client-top mb-4" style="height:auto" v-if="user_role === 'escort'">
            <div class="mobile-client-strip">
                <div
                    v-for="(u, index) in users"
                    :key="index"
                    class="mobile-client-card"
                    :id="'chat' + u.userid"
                    @click="select_mobile(u.userid)"
                >
                    <img
                    src="../../assets/no_image.png"
                    alt=""
                    class="mobile-client-avatar"
                    />

                    <div class="mobile-client-name">
                        <span
                        class="comment-badge"
                        v-if="chatHistoryList.some(c => c.sender_id == u.userid)"
                        >
                        <i class="fa fa-comment"></i>
                        <span class="badge-count">
                            {{ chatHistoryList.filter(c => c.sender_id == u.userid).length }}
                        </span>
                        </span>
                        {{ u.username }}
                    </div>

                    <div class="mobile-client-wallet">
                    {{ formatToken(u.dayruns_token) }}{{ token_label }}
                    </div>
                </div>
            </div>
         </div>

         <div class="chat-content">
            <div
            class="col-sm-5 leftbar escort-hide-show"
            v-if="user_role === 'escort'"
            >
                <!-- Header -->
                <div class="escort-users-header">
                    <i class="fa fa-user-friends"></i>
                    <span>Clients</span>
                </div>

                <!-- Client List -->
                <div class="client-list">
                    <div
                    v-for="(u, index) in users"
                    :key="index"
                    class="client-card"
                    :id="'chat' + u.userid"
                    @click="select(u.userid)"
                    >
                    <img
                        src="../../assets/no_image.png"
                        alt=""
                        class="client-avatar"
                    />

                    <div class="client-info">
                        <div class="client-name">
                        {{ u.username }} 
                        <span
                        class="comment-badge"
                        v-if="chatHistoryList.some(c => c.sender_id == u.userid)"
                        >
                        <i class="fa fa-comment"></i>
                        <span class="badge-count">
                            {{ chatHistoryList.filter(c => c.sender_id == u.userid).length }}
                        </span>
                        </span>

                        </div>
                        <div class="client-wallet">
                        {{ formatToken(u.dayruns_token) }}{{ token_label }}
                        </div>
                    </div>
                    <i class="fa fa-arrow-right client-arrow"></i>
                    </div>
                </div>
            </div>

            <div class="col-sm-5 leftbar guest-hide" v-if="user_role === 'guest'">
                <img
                    :src="escort_data.profilepic"
                    alt=""
                    width="70%"
                    height="50%"
                    class="large-profile-pic1"
                    style="border-radius: 10px;"
                >
            </div>

            <div class="col-sm-7 rightbar" style="height:auto">
                <div>
                    <div class="chat-header">
                        <span v-if="escort_data.profilepic == NULL" class="select-profile">
                            <img
                                src="../../assets/user4.png"
                                alt=""
                                width="60px"
                                height="60px"
                                class="large-profile-pic"
                                style="border-radius: 50%;"
                            >
                        </span>
                        <span v-else class="select-profile">
                            <img
                                :src="escort_data.profilepic"
                                alt=""
                                width="60px"
                                height="60px"
                                class="large-profile-pic"
                                style="border-radius: 50%;"
                            >
                        </span>
                        <span>
                            <h4>&nbsp;{{ escort_data.user_name }} 
                                <span v-if="escort_data.activation_paid == 1" class="verified-icon" title="Verified">
                                <i class="fa fa-check-circle text-success"></i>
                            </span>
                            </h4>
                            <p style="font-size: 14px; padding: 0 0 0 5px;">{{ escort_data.bio }}</p>
                        </span>
                    </div>
                    <div class="chat-board-null" v-if="showChatBoardNull"></div>
                    <div class="chat-board" v-if="showChatBoard">
                        <div class="chat-size mt-2">
                            <div v-for="(chat, index) in chat_message" :key="index">
                                <div class="chat-view-left " v-if="chat.sender_id != userid">
                                    <div class="message-date">
                                        <div class="message">
                                            {{ chat.message }}
                                        </div>
                                        <p class="date mt-2"> {{ new Date(chat.created_at).toDateString() }}</p>
                                    </div>
                                </div>
                                <div class="chat-view-right" v-else-if="chat.sender_id == userid">
                                    <div class="message-date-right">
                                        <div class="message-right">
                                            {{ chat.message }}
                                        </div>
                                        <p class="date mt-2"> {{ new Date(chat.created_at).toDateString() }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="chat-input">
                            <input class="chat-input" type="text" placeholder="Type a message here..."    @keyup.enter="sendMessage" v-model="message">
                        </div>
                        <span class="p-viewer">
                            <img src="../../assets/entypo_attachment.png" alt="" width="22px">&nbsp;
                            <button class="btn btn-info" @click="sendMessage()">Send</button>
                        </span>
                    </div>
                </div>
            </div>
         </div>
</div>
</template>
<script>
import swal from 'sweetalert2';
import socket from "@/socket";

export default {
    components: {
     
    },

data() {
  return {

      image_path: '',
      myprofile: [],
      isMessage: false,
      chat_message: [],
      user_info: '',
      message: '',
      sender_id: '', // your guest or escort ID
      user_id: '',   // your ID from auth or session
      escort_id: '', // escort ID if guest is chatting
      user_photo: '',
      user_role: '',
      escort_data: '',
      userid: '',
      receiver_id: '',
      users: [],
      showGuestList: false,
      refreshInterval: null,
      showChatBoard: false,
      chatHistoryList: [],
      chatId: '',
      showChatBoardNull: true,
      token_label: process.env.VUE_APP_TOKEN_LABEL
  };
},

beforeMount(){
    this.receiver_id =  this.$route.params.escortid;
    this.listEscortConnections(this.receiver_id);
    this.listMyProfile(this.receiver_id);
},

async mounted(){
    this.userid = localStorage.getItem("userid");
    this.user_role = localStorage.getItem("role");

    this.markRead(this.receiver_id)
    await this.get_chat_history();
    await this.select(this.receiver_id)
    await this.select_mobile(this.receiver_id)

    /* SOCKET LISTENER */
    socket.on("chatMessage", msg => {
        this.chat_message.push({
          sender_id: msg.sender_id,
          message: msg.message,
          created_at: msg.created_at,
        });

      });
},
beforeUnmount() {
  // Clear interval to avoid memory leak
  clearInterval(this.refreshInterval);
},

methods: { 
    formatToken(value) {
        const num = Number(value);

        if (!Number.isFinite(num)) {
        return value ?? '0';
        }

        // Keep small values readable, show one decimal for thousands, and cap million-plus at 1m.
        if (num >= 1000000) {
        return '1m';
        }

        if (num >= 1000) {
        const abbreviated = (num / 1000).toFixed(1).replace(/\.0$/, '');
        return `${abbreviated}k`;
        }

        return new Intl.NumberFormat('en-US').format(num);
    },
    async get_chat_history() {
      try {

        const res = await this.$http.get(`/get-chat-history`);

        this.chatHistoryList = res.data.data;
       
      } catch (err) {
        console.error("Chat load error:", err);
      }
    },

    formatPrice(value) {
      return new Intl.NumberFormat('en-NG', {
    //   style: 'currency',
    //   currency: 'NGN',
      minimumFractionDigits: 0
    }).format(value);
    },

    toggleGuestList() {
        this.showGuestList = !this.showGuestList;
    },

    async listEscortConnections(escortid) {
      try {
        const res = await this.$http.get(`/escort-chat-connections/${escortid}`);
        this.users = res.data.data;

      } catch (err) {
        console.error("Connection list error:", err);
      }
    },

    // Load selected chat
    async select(userid) {
        try {
            this.showChatBoard = true
            this.showChatBoardNull = false

            const res = await this.$http.get(`/chat-history/${userid}`);

            this.chat_message = res.data.data;
            this.user_info = res.data.data || {};
            this.user_photo = res.data.data?.profilepic || '';
            this.receiver_id = userid
            this.message = "";
            
            this.$store.commit("SET_UNREAD_MESSAGES", this.chat_message.length)
            await this.get_chat_history();
        } catch (err) {
            console.error("Chat load error:", err);
        }
    },

    // Load selected chat
    async select_mobile(userid) {
        try {

            this.showChatBoard = true
            this.showChatBoardNull = false
            
            const res = await this.$http.get(`/chat-history/${userid}`);

            this.chat_message = res.data.data;
            this.user_info = res.data.data || {};
            this.user_photo = res.data.data?.profilepic || '';
            this.receiver_id = userid
            this.message = "";
            await this.get_chat_history();
        } catch (err) {
            console.error("Chat load error:", err);
        }
    },
    
    // Send chat message
    async sendMessage() {
      if (!this.message.trim()) return;
      try {

        const chatPayload = {
            receiver_id: this.receiver_id,
            message: this.message
        };

        const res = await this.$http.post('/send-chat', chatPayload);

        if (res.data.success) {
          await localStorage.setItem("chatId", res.data.chat_id)
          this.message = "";

        }
      } catch (err) {
        console.error("Message send error:", err);
        swal.fire({
            icon: "error",
            title: 'Error',
            width:450,
            height:2,
            text: err.response ? err.res.data.message : err.message,
        });
      }
    },

    async listMyProfile(userid){
        try{
        const response = await this.$http.get(`/list-escort-chat-profile/${userid}`, )
        this.escort_data = response.data.data;
        if (this.escort_data.account_type !== this.user_role) {
            this.showChatBoardNull = false
            this.showChatBoard = true
        }
    
        }catch (err) {
            console.log(err);
        }
    },

    // Load selected chat
    async markRead(userid) {
      try {
        this.chatId = localStorage.getItem("chatId");
        const res = await this.$http.get(`/mark-chat-read/${userid}/${this.chatId}`);

        const message = res.data.message;
        console.log(message)

      } catch (err) {
        console.error("Chat load error:", err);
      }
    },

    backProfile() {
        this.showChatBoard = false
        this.selectedUserId = null
        this.$router.back();
    }
  }
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');
.comment-badge {
  position: relative;
  display: inline-block;
  font-size: 1.1rem;
  color: #D33E74;
}

.badge-count {
  position: absolute;
  top: -6px;
  right: -8px;
  background: #D33E74;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 999px;
  line-height: 1;
}

.mobile-client-strip {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(90px, 1fr);
  gap: 12px;
  overflow-x: auto;
  padding: 10px 6px 14px;
  scroll-snap-type: x mandatory;
}

.mobile-client-strip::-webkit-scrollbar {
  display: none;
}

.mobile-client-card {
  scroll-snap-align: start;
  text-align: center;
  background: #1e1e1e;
  border-radius: 12px;
  padding: 10px 8px;
  cursor: pointer;
  transition: transform 0.15s ease, background 0.15s ease;
}

.mobile-client-card:hover {
  background: #262626;
  transform: translateY(-2px);
}

.mobile-client-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #D33E74;
}

.mobile-client-name {
  margin-top: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-client-wallet {
  font-size: 0.75rem;
  color: #bbb;
}

.escort-users-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 1rem;
  color: #D33E74;
  padding: 12px 10px;
  border-bottom: 1px solid #eee;
}

.client-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 10px;
}

.client-card {
  display: grid;
  grid-template-columns: 60px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.client-card:hover {
  background: #333;
}

.client-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.client-info {
  display: grid;
  gap: 4px;
}

.client-name {
  font-weight: 600;
  font-size: 0.95rem;
  color: #fff;
}

.client-wallet {
  font-size: 0.85rem;
  color: #666;
}

.client-arrow {
  color: #bbb;
  font-size: 1rem;
}

.chat-row {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.arrow-right {
  margin-right: auto;   /* pushes arrow to extreme right */
}

.chat-client-top{
    display: none;
}
.show-mobile{
    display: none;
}

.chat-bar-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.chat-bar{
    display: none;
}
.escort-hide-show{
    display: flex;
    flex-direction: column;
}
.guest-hide{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height:auto; 
    text-align: center;
}
.back-profile{
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    color: #fff;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 13px;
}
.container-fluid{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 120px 0 0 0;
}
.chat-content{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}
.escort-users{
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    text-align: center;
    color: #000;
    background: #fff;
    padding: 20px 0 10px 0;
    margin-top: 10px;
}
.large-profile-pic {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.p-viewer {
    float: right;
    margin-top: -52px;
    margin-right: 18px;
    position: relative;
    z-index: 1;
    cursor:pointer;
    .btn-info {
        margin-top: -4px;
        border-radius: 25px;
        background: #242325;
        font-size: 10px;
    }
  }
.chat-head{
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 50px;
        width: 100%;
        //margin-left: -30px;
        background: #D33E74;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 16px;
        line-height: 28px;
        text-align: center;
        color: #FFFFFF;
 
    }
    .leftbar{
        height: auto;
        background: #111112;
        border-right:1px solid #242325;
        overflow-y:scroll;
        .chat {
            display: flex;
            flex-direction: row;
            align-items: center;
            box-sizing: border-box;
            padding: 5px 0 4px 0;
            cursor: pointer;

            span > h4 {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 14px;
                text-align: left;
                color: #FFFFFF;
            }
            span > p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 10px;
                text-align: left;
                color: #767475;
                margin-top: -8px;
            }
        }
        .chatx {
            display: flex;
            flex-direction: row;
            align-items: center;
            box-sizing: border-box;
            margin: 50px;
            margin-bottom: -30px;
            background: #1C1C1D;
            border-right: 2px solid #D33E74;
            cursor: pointer;

            span > h4 {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 14px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
            }
            span > p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 10px;
                text-align: left;
                color: #767475;
                margin-top: -8px;
            }
        }
        
    }
    .rightbar{
        box-sizing: border-box;
        height: auto;
        background: #111112;
        .chat-header {
            display: flex;
            flex-direction: row;
            align-items: center;
            box-sizing: border-box;
            margin: 50px;
            padding: 0 0 10px 0;
            cursor: pointer;
            border-bottom: 1px solid #312F33;

            span > h4 {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
            }
            span > p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                text-align: left;
                color: #767475;
                margin-top: -8px;
            }
            .select-profile{
                background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
                border: 3px solid #D33E74;
                border-radius: 50%;
                display: block;
                margin-top: 5px;
            }
        }
        .chat-board-null{
            height: 450px;
        }
        .chat-size {
            width:100% !important;
            height: 450px;
            overflow-y: scroll;
        }
        .chat-view-left {
            display: flex;
            flex-direction: row;
            
            .message-date{
                .message {
                    background: #2F2F2F;
                    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.02);
                    border-radius: 40px;
                    height: auto;
                    padding: 0 10px 0 10px;
                    font-family: 'Open Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;
                }
                .date{
                    flex-direction: column;
                    font-family: 'Open Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    color: #4F4F4F;
                }
            }
            
        }
        .chat-view-right {
            display: flex;
            justify-content: right;

            .message-date-right{
                
                .message-right {
                    background: #D33E74;
                    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.02);
                    border-radius: 40px;
                    height: auto;
                    font-family: 'Open Sans';
                    font-weight: 400;
                    font-size: 12px;
                    color: #D9D9D9;
                    padding: 0 10px 0 10px;
                }
                .date{
                    flex-direction: column;
                    font-family: 'Open Sans';
                    font-weight: 400;
                    font-size: 12px;
                    text-align: right;
                    color: #4F4F4F;
                }
                .select-profile{
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
                    border: 3px solid #D33E74;
                    border-radius: 97px;
                    display: block;
                    margin-top: 5px;
                }
            }
            
        }

    }
    .chat-input {
        width: 100%;
        height: 40px;
        background: #1C1C1D;
        border-radius: 61px;
        margin-bottom: 20px;
        font-family: 'Mulish';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        text-align: left;
        color: #FFFFFF;
        padding-left: 10px;

    }

    @media screen and (max-width: 700px) {

        .chat-client-top{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
        .show-mobile{
            display: flex;
        }
        .client-top{
        height: auto;
        background: #111112;
        border-right:1px solid #242325;
        overflow-y:scroll;

        .chat {
            display: flex;
            flex-direction: row;
            align-items: center;
            box-sizing: border-box;
            padding: 20px 0 0 20px;
            cursor: pointer;

            span > h4 {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 14px;
                text-align: left;
                color: #FFFFFF;
            }
            span > p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 10px;
                text-align: left;
                color: #767475;
                margin-top: -8px;
            }
        }
        .chatx {
            display: flex;
            flex-direction: row;
            align-items: center;
            box-sizing: border-box;
            margin: 50px;
            margin-bottom: -30px;
            background: #1C1C1D;
            border-right: 2px solid #D33E74;
            cursor: pointer;

            span > h4 {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 14px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
            }
            span > p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 10px;
                text-align: left;
                color: #767475;
                margin-top: -8px;
            }
        }
        
    }

        .container{
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 50px;
            width: 94%;
            margin-left: 10px;
            background: #D33E74;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 16px;
            line-height: 28px;
            text-align: center;
            color: #FFFFFF;
    
           
     
        }
        .leftbar{
            height: auto;
            background: #111112;
            border-bottom:1px solid #242325;
            overflow:scroll;
            
            .chat {
    
                display: flex;
                flex-direction: row;
                align-items: center;
                box-sizing: border-box;
                margin: 50px;
                margin-bottom: -30px;
    
                
                span > h4 {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: left;
                    color: #FFFFFF;
                }
                span > p {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 10px;
                    text-align: left;
                    color: #767475;
                    margin-top: -8px;
                }
            }
            
        }

        .rightbar{
            box-sizing: border-box;
            height: auto;
            background: #111112;
            overflow:scroll;

        .chat-header {
            display: flex;
            flex-direction: row; 
            align-items: center;
            box-sizing: border-box;
            margin: 0px;
            margin-bottom: 0px;
            cursor: pointer;
            border-bottom: 1px solid #312F33;
            width: 100%;

            span > img {
                //width: 100%;
                border-radius: 43px;
            }
            span > h4 {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                text-align: left;
                color: #FFFFFF;
            }
            span > p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                text-align: left;
                color: #767475;
                
            }
        }


        }

        .guest-hide{
            display: none;
        }
        .escort-hide-show{
            display: none;
        }
        .chat-bar{
            display: flex;
            flex-direction: row;
            justify-content: left;
            align-items: center;
            color: #fff;
        }

}
</style>